export type StorageKey = 'USER' | 'LANGUAGE';

export const StorageKeys: Record<StorageKey, string> = {
  USER: 'user_data',
  LANGUAGE: 'user_language'
};
